import React from "react";
import MedalTableTailwind from "../admin/MedalTableTailwind";
import TailwindPageWrapper from "../generic/TailwindPageWrapper";

function PublicMedalTable() {
  return (
    <TailwindPageWrapper>
      <div className="-mt-24">
        <MedalTableTailwind />
      </div>
    </TailwindPageWrapper>
  );
}

export default PublicMedalTable;

